import { connect } from "react-redux";

import {
  addSocialMediaPlatforms,
  cancelProcess,
  createUserProfile,
  fetchLoggerDetails,
  fetchMe,
  getProcessList,
  removeIp,
  updateLoggerDetails,
} from "../../../store/user/duck";
import { getStreamDetails } from "../../../store/videogrid/duck";
import Header from "./component";

const HeaderContainer = connect(
  // Map state to props
  (state) => ({
    user: state.user.user,
  }),
  // Map actions to dispatch and props
  {
    fetchMe,
    createUserProfile,
    addSocialMediaPlatforms,
    fetchLoggerDetails,
    updateLoggerDetails,
    removeIp,
    getProcessList,
    cancelProcess,
    getStreamDetails,
  },
)(Header);

export default HeaderContainer;
